export const GET_DEMOGRAPHICS_COMPARE = 'get_demographics_compare';
export const RESET_DEMOGRAPHICS_COMPARE = 'reset_demographics_compare';
